<template>
  <div class="news">
    <div class="main-banner" :style="'background-image: url('+bannerList+');'">
			<div class="banner-title">
				<h2>新闻动态</h2>
				<h3>News</h3>
			</div>
		</div>
    <div class="container">
      <ul class="newsNav">
        <li v-for="item in $t('news.nav')" :class="item.id==typeId?'active':''"  :key="item.id" @click="newsClick(item.id)">{{item.name}}</li>
      </ul>
      <div class="newList">
        <div class="newSlide" v-for="item in newsList">
          <router-link :to="'/news-details?newsId='+item.id">
            <div class="left wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20"><img :src="item.title_pic" alt=""></div>
            <div class="right wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
              <h4 class="ellipsis">{{$AppLang == 'en' ? item.title_en : item.title}}</h4>
              <span>{{item.create_time}}</span>
              <p class="ellipsis">{{$AppLang == 'en' ? item.subtitle_en : item.subtitle}}</p>
            </div>
          </router-link>
        </div>
      </div>
			<el-pagination
				background layout="prev, pager, next"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:total="pageCount">
			</el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
  	name: 'news',
  	data() {
  		return {
				newsList: [],
				bannerList: [],
				typeId: 1,
				pageStart: 1,
				pageTotal: 4,
				pageCount: 50
  		};
  	},
    mounted() {
      this.newsPage();
			this.bannerApi();
    },
		methods:{
			handleSizeChange(val) {
				//console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.pageStart = val;
				this.newsPage();
				//console.log(`当前页: ${val}`);
			},
			newsClick(e){
				this.typeId = e;
				this.newsPage();
			},
			newsPage(){
				var that = this;
        var options={ live:false};
				//新闻列表请求接口
				that.$api.post(
					'/news/websiteNews',
					{
						type: that.typeId,
						pageStart: that.pageStart,
						pageTotal: that.pageTotal
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							that.newsList = list.data;
							//that.pageCount = list.pageCount;
							if(that.pageStart * that.pageTotal < list.pageCount
								&& (that.pageStart + 1) * that.pageTotal > list.pageCount) 
								that.pageCount = (that.pageStart + 1) * that.pageTotal;
							else that.pageCount = list.pageCount;
              that.$nextTick(function(){
              	var wow=new that.$wow.WOW(options).init();
              });
						}else{
							alert(res.data.msg);
						}

					}
				);
			},
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 3
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}
					}
				);
			}
		},
		created() {


		},
    metaInfo: {
      title: '佛山鼎吉-新闻动态', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.news{
	background: #FFFFFF;
	padding-bottom: 50px;
}
.news .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.news .newsNav{
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
  margin-top: 60px;
}
.news .newsNav li{
	padding: 6px  26px;
	margin-left: 3px;
	color: #717171;
	font-size: 14px;
	transition: all .5s linear;
	cursor: pointer;
}
.news .newsNav li::before{
  content: "|";
  position: relative;
  top: 0;
  left: -29px;
  color: #e2e2e2;
}
.news .newsNav li:first-child::before{
  display: none;
}
.news .newsNav li:hover{
  background-color: #333;
  color: rgba(255,255,255,.62);
}
.news .newsNav li.active{
  background-color: #333;
  color: rgba(255,255,255,.62);
}

.newSlide{
	margin-bottom: 20px;
}
.newSlide>a{
  display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e3e3e3;
	padding-bottom: 15px;
  text-decoration: none;
}
.newSlide .left{
  width: 30%;
}
.newSlide .right{
	width: 65%;
}
.newSlide .right h4{
	font-size: 20px;
	margin-bottom: 15px;
  color: #101010;
}
.newSlide .right span{
	font-size: 14px;
	margin-bottom: 10px;
  color: #101010;
	display: block;
}
.newSlide .right p{
	font-size: 14px;
	color: #aeaeae;
}
.news .el-pagination.is-background .el-pager li:not(.disabled).active{
	background-color: #333;
	color: rgba(255,255,255,.62);
}
.newList{
  min-height: 200px;
	margin-top: 50px;
	margin-bottom: 60px;
}
@media (max-width: 992px){
  .news{
    padding-top: 0;
  }
  .newSlide a{
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
  .newSlide .left,.newSlide .right{
    width: 100%;
  }
  .newSlide .right h4{
    font-size: 16px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/news.vue